import { Http } from "@Services";
import IMediaResponse, { IMediaObject } from "./interfaces";

export const postMediaImage = async (
    imageFromData: FormData
): Promise<IMediaObject> => {
    try {
        const { image_id } = await Http.Request<IMediaResponse>({
            method: "POST",
            url: "/media",
            data: imageFromData,
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });

        return {
            image_id,
            img: image_id, //concated url
            fid: image_id, // to be send to backend//clean
            publicUrl: image_id, //to be sent on poll creation
        };
    } catch (error) {
        // @ts-ignore
        throw Error(error);
    }
};

export const DeleteMediaImage = async (fid: string): Promise<void> => {
    try {
        await Http.Request<IMediaResponse>({
            method: "DELETE",
            url: `/media/${fid}`,
        });
    } catch (error) {
        // @ts-ignore
        throw Error(error);
    }
};

export default {
    postMediaImage,
    DeleteMediaImage,
};
